module.exports = __webpack_public_path__ + "assets/img/qlg2.28ab2fb3.jpg";